var $efabfff9907cf818$exports = {};
$efabfff9907cf818$exports = {
    "replaceMessage": `Spustite datoteko za zamenjavo`
};


export {$efabfff9907cf818$exports as default};
//# sourceMappingURL=sl-SI.mjs.map
